import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import '../App.css';

function RankHype() {
  const [mcs, setMcs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Função para alternar o estado do menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // useEffect para buscar o JSON da API
  useEffect(() => {
    axios.get('https://scoreboard-j6oz.onrender.com/mcs/ranking-hype')
      .then(response => {
        setMcs(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Houve um erro ao buscar os dados:", error);
        setLoading(false);
      });
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Navbar */}
      <nav className="navbar navbar-dark bg-primary">
        <div className="container">
          <button className="navbar-toggler" type="button" onClick={toggleMenu}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <Link className="navbar-brand" to="/">
            <i className="fa d-inline fa-lg fa-circle-o"></i>
            <b>Rhymes Score</b>
          </Link>
          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/topbigfour">Top 5 - Big Four - São Paulo SP</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/rankhype">Ranking do Hype - Big Four - São Paulo SP</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">Sobre Nós</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Título da Página */}
        <div className="py-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="editions-title">Ranking do Hype - Big Four - São Paulo SP - 2025</h2>
              </div>
            </div>
          </div>
        </div>

      {/* Lista de MCs em Cards */}
      <div className="container flex-grow-1">
        <div className="row">
          {loading ? (
            <div className="col-md-12 text-center">
              <p>Carregando...</p>
            </div>
          ) : (
            mcs.map((mc, index) => (
              <div key={index} className="col-md-12 mb-4">
                <div className="card h-100 shadow">
                  <div className="card-body d-flex align-items-center">
                    <Link to={`/profile/${mc.nickName}`}>
                      <img 
                        className="img-fluid rounded-circle me-3" 
                        src={mc.photo} 
                        width="80" 
                        alt={`Foto de ${mc.nickName}`} 
                      />
                    </Link>
                    <div className="text-left">
                      <h5 className="card-title mb-1" style={{ 
                        fontFamily: "'Roboto', sans-serif", 
                        fontWeight: '500', /* Peso médio: deixa mais leve e elegante */
                        color: '#333', /* Cinza escuro, não preto chapado */
                        textTransform: 'capitalize',
                        fontSize: '1.15rem', 
                        letterSpacing: '0.3px' /* Leve respiro entre as letras */
                      }}>
                        {index + 1}º {mc.nickName}
                      </h5>

                      {/* Visualizações com Ícone de Play Vermelho */}
                      <p className="card-text mb-0 d-flex align-items-center" style={{ gap: '8px', color: '#666', fontSize: '0.9rem' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                          <polygon points="10 8 16 12 10 16 10 8" fill="#dc2626"></polygon>
                        </svg>
                        <span>Visualizações no YouTube: <strong>{mc.totalViews.toLocaleString()}</strong></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Rodapé */}
      <footer className="bg-primary text-white text-center py-3">
        <p className="mb-0">© 2024 Rhymes Score. Todos os direitos reservados.</p>
      </footer>
    </div>
  );
}

export default RankHype;
